// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"9e7279d3","199":"feffe3a9","301":"cf5c61bf","311":"c5de435f","342":"b3218618","343":"945af55c","453":"dcd7d1ba","629":"fc819818"}[chunkId] + ".chunk.js";
};